import * as searchSuggestDatasource from 'AWFWSK/Data/Datasources/SearchSuggestDatasource';
import 'kendo/kendo.autocomplete';

export default class SearchControl {
    private $searchTerm: JQuery;
    private $btnSearch: JQuery;
    private searchUrl: string;

    constructor(searchUrl: string, $searchTerm: JQuery, $btnSearch: JQuery) {
        this.$searchTerm = $searchTerm;
        this.$btnSearch = $btnSearch;
        this.searchUrl = searchUrl;
    }
    public initialize() {
        if (this.$btnSearch != null) {
            this.$btnSearch.on('click', (e) => {
                e.preventDefault();
                this.search(); /* search */
            });
        }


        /* Suggest autocomplete */
        this.$searchTerm.kendoAutoComplete({
            noDataTemplate: null,
            clearButton: false,
            dataTextField: 'suggestion',
            template: '#:suggestion#',
            select: (e) => {
                if (e.dataItem && e.dataItem.suggestion) {
                    this.search(e.dataItem.suggestion);
                }
            },
            dataSource: searchSuggestDatasource.create()
        });

        this.$searchTerm.on('keyup', (e) => {
            if (e.keyCode === 13) { /* Enter */
                this.search();
            }
        });
    }

    private search(term?: string) {
        if (term == null) {
            term = this.$searchTerm.val().toString();
        }
        if (term != null && term !== '') {
            window.location.assign(this.searchUrl + "#term=" + term);
            //clear search to make search page functional
            this.$searchTerm.val('')
        }
    }

    public destroy() {

    }
}